import { Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'MU3 Form';
  environment = environment.production ? 'Production' : 'Development';
  buildTime = new Date().toISOString();
  version = '0.0.1';
}
